import { StackProjections } from './stack-projections.js';
import { isStackValid } from './stack.js';
export const StackInvariants = {
    isStackValid: (self, state, ctx)=>{
        const stackProjections = new StackProjections(ctx.componentReader);
        const { stacks } = stackProjections.getStacks(state);
        const entityStacks = stacks.filter((stack)=>stack.parentEntityId === self.id);
        if (entityStacks.length === 0) {
            throw new Error(`Stack ${self.id} not found, cannot validate stack! Make sure the stack exists and has a valid stackId.`);
        }
        return entityStacks.every((stack)=>isStackValid(stack.items, stack.limits));
    }
};

//# sourceMappingURL=stack-invariants.js.map